export const getSessionSummary = (purchasedPackageItems) => {
  if (!purchasedPackageItems?.length) return null

  let totalUnits = 0
  let fulfilledUnits = 0
  let remainingUnits = 0

  for (const item of purchasedPackageItems) {
    totalUnits += item.numUnits ?? 0
    fulfilledUnits += item.fulfilledUnits ?? 0
    remainingUnits += item.remainingUnits ?? 0
  }

  return { totalUnits, fulfilledUnits, remainingUnits }
}

export const getTransactionsUrl = (purchasedPackage) => {
  const contactId = purchasedPackage?.contactUuid
  const offeringId = purchasedPackage?.packageUuid
  if (!contactId || !offeringId) return null
  return `/app/sell/transactions?contactId=${contactId}&offeringId=${offeringId}`
}
